var Utilites = class Utilites {

    // --START--  Handle Phone Formatting
    isNumericInput(event) {
        const key = event.keyCode;
        return ((key >= 48 && key <= 57) || // Allow number line
            (key >= 96 && key <= 105) // Allow number pad
        );
    }

    isModifierKey(event) {
        const key = event.keyCode;
        return (event.shiftKey === true || key === 35 || key === 36) || // Allow Shift, Home, End
            (key === 8 || key === 9 || key === 13 || key === 46) || // Allow Backspace, Tab, Enter, Delete
            (key > 36 && key < 41) || // Allow left, up, right, down
            (
                // Allow Ctrl/Command + A,C,V,X,Z
                (event.ctrlKey === true || event.metaKey === true) &&
                (key === 65 || key === 67 || key === 86 || key === 88 || key === 90)
            )
    }

    enforceFormat(event) {
        // Input must be of a valid number format or a modifier key, and not longer than ten digits
        if (!this.isNumericInput(event) && !this.isModifierKey(event)) {
            event.preventDefault();
        }
    }

    formatToPhone(event) {
        if (this.isModifierKey(event)) { return; }

        // I am lazy and don't like to type things more than once
        const target = event.target;
        const input = target.value.replace(/\D/g, '').substring(0, 10); // First ten digits of input only
        const areaCode = input.substring(0, 3);
        const middle = input.substring(3, 6);
        const last = input.substring(6, 10);

        if (input.length > 6) { target.value = `${areaCode}-${middle}-${last}`; }
        else if (input.length > 3) { target.value = `${areaCode}-${middle}`; }
        else if (input.length > 0) { target.value = `${areaCode}`; }
    }
    // --END--  Handle Phone Formatting


    // Handle account number Formatting

    enforceAccountFormat(event) {
        this.enforceFormat(event);
        this.formatToAccountNumber(event);
    }

    formatToAccountNumber(event) {

        // if (this.isModifierKey(event)) { return; }

        // I am lazy and don't like to type things more than once
        let target = event.target;

        // let last = target.value.substring(target.value.length-1, target.value.length);

        // console.log(input.length)
        let input = target.value.replace(/\D/g, '').substring(0, 12); // First ten digits of input only

        let fund = input.substring(0, 5);
        let org = input.substring(5);
        let prgm = "";

        if (input.length > 10) {
            prgm = input.substring(input.length - 2, input.length);
            org = org.substring(0, org.length - 2);
        }

        // target.value = `${fund}-${org}-${prgm}`;

        if (input.length > 8) { target.value = `${fund}-${org}-${prgm}`; }
        else if (input.length > 4) { target.value = `${fund}-${org}`; }
        else if (input.length > 0) { target.value = `${fund}`; }
    }


    scrollParentToChild(parent, child) {
        console.log('----------------------')
        console.log(parent)
        console.log(child)
        // Where is the parent on page
        var parentRect = parent.getBoundingClientRect();
        // What can you see?
        var parentViewableArea = {
            height: parent.clientHeight,
            width: parent.clientWidth
        };
        // Where is the child
        var childRect = child.getBoundingClientRect();
        // Is the child viewable?
        var isViewable = (childRect.top >= parentRect.top) && (childRect.bottom <= parentRect.top + parentViewableArea.height);
        // if you can't see the child try to scroll parent
        if (!isViewable) {
            // Should we scroll using top or bottom? Find the smaller ABS adjustment
            const scrollTop = childRect.top - parentRect.top;
            const scrollBot = childRect.bottom
            parent.scrollTo(0, scrollTop < 0 ? 0 : scrollTop)

            child.focus()
        }


    }

    PrintElem(elem) {
        var mywindow = window.open('', 'PRINT', 'height=400,width=600');

        mywindow.document.write('<html><head><title>' + document.title + '</title>');
        mywindow.document.write('</head><body >');
        mywindow.document.write('<h1>' + document.title + '</h1>');
        mywindow.document.write(elem.innerHTML);
        mywindow.document.write('</body></html>');

        mywindow.document.close(); // necessary for IE >= 10
        mywindow.focus(); // necessary for IE >= 10*/

        mywindow.print();
        mywindow.close();

        return true;
    }
}




export default new Utilites()
